import React from "react";
import style from "./ResultDetail.module.scss";
import { MaterialCard } from "../Products/MaterialCard";
import { Disclaimer } from "../components/Disclaimer";
import { DISCLAIMER_TEXT } from "./utils";

const ResultDetail = ({ groups, loading, onBack, onMaterialSelect }) => {
  return (
    <div className={style.detail}>
      <div className={style.detail_header}>
        <button type="button" className={style.back_link} onClick={onBack}>
          ‹ Back
        </button>
      </div>

      {loading ? (
        <div className={style.shimmer_group}>
          <span className={style.shimmer_heading} />
          <span className={style.shimmer_card} />
          <span className={style.shimmer_card} />
          <span className={style.shimmer_card} />
        </div>
      ) : groups.length ? (
        groups.map((group) => (
          <div key={group.productCategoryId} className={style.category_group}>
            <h5 className={style.category_heading}>{group.productCategoryDesc}</h5>
            <div className={style.material_list}>
              {group.materials.map((material) => (
                <MaterialCard
                  key={material.materialId}
                  material={material}
                  type="VIEW_PRODUCT"
                  onClick={(materialId) => onMaterialSelect(group.productCategoryId, materialId)}
                />
              ))}
            </div>
          </div>
        ))
      ) : (
        <p className={style.empty}>No products found.</p>
      )}

      <Disclaimer>{DISCLAIMER_TEXT}</Disclaimer>
    </div>
  );
};

export default ResultDetail;
